var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", { staticClass: "config__group group" }, [
    _c("h2", { staticClass: "title-4 group__title" }, [
      _vm._v(_vm._s(_vm.item.name))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "group__options" },
      _vm._l(_vm.item.items, function(option) {
        return _c("config-option", {
          key: option.id,
          attrs: { option: option },
          on: { updatedChoice: _vm.handleChoiceUpdate }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-535adc5e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-535adc5e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!/Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/partials/ConfigGroup.vue
// module id = 89
// module chunks = 0